class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.mainButton = null;
    this.observer = null;
    this.stickyButton = null;
    this.variantSelect = null;
  }

  connectedCallback() {
    const sectionId = this.dataset.sectionId;
    this.mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    this.stickyButton = this.querySelector('[data-sticky-atc-btn]');
    this.variantSelect = this.querySelector('[data-sticky-variant]');

    if (!this.mainButton) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );

    this.observer.observe(this.mainButton);

    if (this.stickyButton) {
      this.stickyButton.addEventListener('click', () => {
        this.syncVariant();
        this.mainButton.click();
      });
    }

    if (this.variantSelect) {
      this.variantSelect.addEventListener('change', () => this.updatePrice());
    }

    document.addEventListener('variant:change', (event) => {
      this.onVariantChange(event.detail);
    });
  }

  syncVariant() {
    if (!this.variantSelect) return;
    const mainForm = this.mainButton.closest('form');
    const mainVariantInput = mainForm?.querySelector('input[name="id"].product-variant-id');
    if (mainVariantInput) {
      mainVariantInput.value = this.variantSelect.value;
    }
  }

  onVariantChange(detail) {
    const priceEl = this.querySelector('[data-sticky-price]');
    if (!priceEl || !detail?.variant) return;

    if (detail.variant.price !== undefined) {
      const price = (detail.variant.price / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
        minimumFractionDigits: 2,
      });
      priceEl.textContent = price;
    }

    if (this.variantSelect) {
      this.variantSelect.value = detail.variant.id;
    }

    if (this.stickyButton) {
      this.stickyButton.disabled = !detail.variant.available;
      this.stickyButton.textContent = detail.variant.available
        ? this.dataset.addToCart
        : this.dataset.soldOut;
    }
  }

  updatePrice() {
    if (!this.variantSelect || !window.stickyAtcVariants) return;
    const variant = window.stickyAtcVariants.find(
      (v) => String(v.id) === String(this.variantSelect.value)
    );
    if (!variant) return;

    const priceEl = this.querySelector('[data-sticky-price]');
    if (priceEl) {
      const price = (variant.price / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
        minimumFractionDigits: 2,
      });
      priceEl.textContent = price;
    }

    if (this.stickyButton) {
      this.stickyButton.disabled = !variant.available;
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

customElements.define('sticky-atc', StickyAtc);
